import { Box, Tag } from '@veracity/vui'
import { Link } from 'react-router-dom'

import { useCurrentUser } from '@/hooks'
import { UserAdministrationSection } from '@/interfaces'

interface Props {
  activeSection: UserAdministrationSection
}

export const UserAdministrationPageMenu = ({ activeSection }: Props) => {
  const { isUser, isAdmin, hasAccessToApi } = useCurrentUser()
  return (
    <Box w="100%" justify="center" gap={2}>
      <Tag
        as={Link}
        to="/profile"
        variant={
          activeSection === UserAdministrationSection.USER_PROFILE
            ? 'subtleBlue'
            : 'subtleGrey'
        }
        text="User Profile"
      />

      {((isUser && hasAccessToApi) || isAdmin) && (
        <Tag
          as={Link}
          to="/api-management"
          variant={
            activeSection === UserAdministrationSection.API_KEY_MANAGEMENT
              ? 'subtleBlue'
              : 'subtleGrey'
          }
          text="API Key Management"
        />
      )}

      {isAdmin && (
        <Tag
          as={Link}
          to="/administration"
          variant={
            activeSection === UserAdministrationSection.ADMINISTRATION
              ? 'subtleBlue'
              : 'subtleGrey'
          }
          text="Admin"
        />
      )}
    </Box>
  )
}
